import { render, staticRenderFns } from "./AccessRightsV2.vue?vue&type=template&id=3574de1e"
import script from "./AccessRightsV2.vue?vue&type=script&lang=js"
export * from "./AccessRightsV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports